module.exports = __webpack_public_path__ + "img/197.c9ffa27b.jpg";